<template>
  <v-layout column wrap  style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-avatar size="40" style="background: #A80D00 !important;">
        <v-icon style="font-size: 24px; color: white !important;">fas fa-tools</v-icon>
      </v-avatar>
      &nbsp;&nbsp;
      <v-toolbar-title style="text-align: left">แจ้งปัญหาการใช้งาน <p style="font-size: 14px; margin-bottom: 0;">เครื่อง AED: {{data_aed.address_name}}</p> </v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="listIssue.length != 0">
        <span>สถานะปัญหา:</span>
         <v-select
          :items="itemsselectStatus"
          v-model="selectKeyStatus"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          style="width: 150px;display: -webkit-inline-box; margin-right: 20px;"
          :menu-props="{ bottom: true, offsetY: true }"
        ></v-select>
      </div>
    </v-toolbar>
    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px;" v-if="listIssue.length != 0">
      <v-data-table
        :headers="headers"
        :items="listIssuePaginated"
        :items-per-page="limit"
        hide-default-footer
        fixed-header
        class="elevation-1 mx-4 data-table-container"
        @click:row="selectedDetailIssue"
        style="cursor: pointer; width: 100%;"
        v-if="listIssue.length != 0"
        height="450px"
      >
        <template v-slot:item.issue_detail="{ item }">
          {{item.issue_detail}}
        </template> 
        <template v-slot:item.issue_status="{ item }">
          <v-chip class="ma-2" small v-if="item.issue_status == 'open'">
            รอการยืนยันปัญหา
          </v-chip>
          <v-chip class="ma-2" small v-else-if="item.issue_status == 'confirm'" color="#ffddb1">
            รอการแก้ไข
          </v-chip>
          <v-chip class="ma-2" small v-else-if="item.issue_status == 'close'" color="#c7e4b5">
            ได้รับการแก้ไขแล้ว
          </v-chip>
          <v-chip class="ma-2" small v-else>
            -
          </v-chip>
        </template> 
        <template v-slot:item.company_owner_name="{ item }">
          {{(item.company_owner_name)? item.company_owner_name:'-'}}
        </template> 
        <template v-slot:item.company_maintenance_name="{ item }">
          {{(item.company_maintenance_name)? item.company_maintenance_name:'-'}}
        </template> 
        <template v-slot:item.create_at="{ item }">
          {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
        </template>
      </v-data-table>
      <v-pagination color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
    <v-layout row wrap justify-center align-center style="margin-top: 20px; height: 50vh;" v-else>
      <h2 style="margin-top: 50px;">ไม่พบข้อมูลการแจ้งปัญหา</h2>
    </v-layout>
  </v-layout>
</template>
<script>
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    selectKey: 'all',
    selectKeyStatus: 'all',
    itemsselectStatus:  [
      { text: 'ทั้งหมด', value: 'all' },
      { text: 'เปิดปัญหา', value: 'open' },
      { text: 'ยืนยันปัญหา', value: 'confirm' },
      { text: 'แก้ไขแล้ว', value: 'close' }
    ],
    search: '',
    headers: [
      { text: 'หัวข้อปัญหา', value: 'issue_detail' },
      { text: 'สถานที่', value: 'address_name' },
      { text: 'สถานะปัญหา', value: 'issue_status' },
      { text: 'ผู้ที่แจ้งปัญหา', value: 'who_create_issue' },
      { text: 'วัน เวลา', value: 'create_at' }
    ],
    listIssue: [],
    aed_id: '',
    data_aed: {},
    page_pagination: 1,
    limit: 10,
    total_page: 0
  }},
  created () {
    this.aed_id = this.$route.query.aed_id
    this.getlistissueAED()
    this.getDataAED()
    if (this.$route.query.typeSearch == 'all' || this.$route.query.typeSearch == 'redcross' || this.$route.query.typeSearch == 'other') {
      this.selectKey = this.$route.query.typeSearch
    }
  },
  watch: {
    page_pagination () {
      // คำนวณข้อมูลที่จะแสดงตาม page
    },
    selectKeyStatus () {
      this.page_pagination = 1
    }
  },
  computed: {
    listIssuePaginated () {
      // คำนวณ total_page
      this.total_page = Math.ceil(this.listIssueFile.length / this.limit)

      // คำนวณข้อมูลที่จะแสดงตาม pagination
      const start = (this.page_pagination - 1) * this.limit
      const end = start + this.limit
      return this.listIssueFile.slice(start, end)
    },
    listIssueFile () {
      if (this.selectKeyStatus !== 'all') {
        return this.listIssue.filter(post => {
          try {
            return post.issue_status.toLowerCase().includes(this.selectKeyStatus.toLowerCase())
          } catch(err) {
          }
        })
      } else {
        return this.listIssue
      }
    }
  },
  methods: {
    routeinfo () {
      this.$router.back()
    },
    getDataAED () {
      this.$api.getDataAED(this.aed_id).then((response) => {
        this.data_aed = response.data.data
      })
    },
    selectedDetailIssue (item) {
      this.$router.push('/information_issue?id='+item.issue_id)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistissueAED () {
      var body = {
        aed_id: this.aed_id
      }
      this.$api.getAllIssueByAEDId(body).then((response) => {
        this.listIssue = response.data.data
        this.listIssue = _.sortBy(this.listIssue, function(dateObj) {
          return new Date(dateObj.create_at)
        }).reverse()
      })
    }
  }
}
</script>
<style media="screen" scoped>
/* >>>.v-textarea.v-text-field--full-width .v-text-field__slot .textarea {
  margin-top: 10px !important;
} */
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}
.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}

>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
    overflow-x: auto;
}

>>>.data-table-container {
    width: 100%;
    max-width: 100%;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}

>>>.primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffe6e6 !important;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/listReport/ListissueForAED.vue